import { IHttpService } from "../HttpService";
import { jwtDecode } from "jwt-decode";
import PaymentInstruction, {
  IPaymentInstruction,
  TPaymentInstruction
} from "../../model/payment/PaymentInstruction";
import PaymentConfirmation, {
  IPaymentConfirmation
} from "../../model/payment/PaymentConfirmation";

export interface IPaymentService {
  validateToken(token: string): Promise<any>;
  decodeInstructionToken(token: string): IPaymentInstruction;
  getPaymentConfirmation(shareCode: string): Promise<IPaymentConfirmation>;
}

const PaymentService = ({
  httpService
}: {
  httpService: IHttpService;
}): IPaymentService => {
  const _http: IHttpService = httpService;
  const _baseUrlTokens: string = "/api/tokens";
  const _baseUrlPayment: string = "/api/payments";
  const _validatePath: string = "validate";
  const _confirmationPath: string = "confirmation";

  return {
    async validateToken(token: string) {
      const path = _http.buildPath(_baseUrlTokens, _validatePath);
      const response = await _http.get(path, {
        params: { token }
      });
      return response;
    },

    decodeInstructionToken(token: string) {
      let decoded: any = jwtDecode(token.replaceAll("%2E", "."));
      let decodedData = decoded["data"] as TPaymentInstruction;

      return PaymentInstruction(decodedData);
    },

    async getPaymentConfirmation(shareCode: string) {
      const path = _http.buildPath(
        _baseUrlPayment,
        _confirmationPath,
        shareCode
      );
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return PaymentConfirmation(responseJSON);
    }
  };
};

export default PaymentService;
